import "styles/pages/page-single-brand.scss";
import React from "react";
import { graphql } from "gatsby";

import Layout from "components/Layout";
import Seo from "components/Seo";
import SubpageHeader from "components/SubpageHeader/SubpageHeader";
import BrandVehicleTile from "components/BrandVehicleTile/BrandVehicleTile";
import BrandVehicleListTile from "components/BrandVehicleListTile/BrandVehicleListTile";
import AvailableVehiclesSlider from "components/AvailableVehiclesSlider/AvailableVehiclesSlider";
import BrandTile from "components/BrandTile/BrandTile";
import TeamPersonTile from "components/TeamPersonTile/TeamPersonTile";
import SectionHeader from "components/SectionHeader/SectionHeader";
import Configurator from "components/Configurator/Configurator";

const TrailerBrandPage = ({ pageContext, data }) => {
	const vehicleType = pageContext.vehicleType.vehicleType;
	const availableVehicles = data.availableVehicles.edges;
	const availableTrailers = data.availableTrailers.edges;
	const brandName = pageContext.title;
	const seo = pageContext.seo;
	const vehicles =
		vehicleType === "trailer"
			? pageContext?.node?.trailers
			: pageContext?.node?.vehicles;
	const categoryInfo = pageContext.node;
	const groups = vehicles?.nodes?.filter((el) => {
		return el.vehicles.groupOrSingle === "group";
	});

	const allTrailerBrands = data.brands.edges;
	const allVehiclesBrands = data.vehiclesBrands.edges;
	const allBrands = [...allTrailerBrands, ...allVehiclesBrands];
	const sortedBrands = allBrands.sort((a, b) => {
		const textA = a.node.name.toUpperCase();
		const textB = b.node.name.toUpperCase();
		return textA < textB ? -1 : textA > textB ? 1 : 0;
	});
	const salesTeam = data.salesTeam.edges;

	return (
		<Layout>
			<Seo title={seo.title} description={seo.metaDesc} />
			<SubpageHeader
				title={`${
					vehicleType === "trailer" ? "Przyczepy" : "Kampery"
				} ${brandName}`}
				location={
					vehicleType === "trailer"
						? `Przyczepy ${pageContext.title}`
						: `Kampery ${pageContext.title}`
				}
			/>
			<section className="brand-header">
				<div className="container">
					<div className="row">
						<div className="col-md-8">
							<div
								className="brand-header__image"
								style={{
									backgroundImage: `url(${
										vehicleType === "trailer"
											? categoryInfo
													?.trailersBrandCategory
													?.mainImage?.sourceUrl
											: categoryInfo
													?.vehiclesBrandCategory
													?.mainImage?.sourceUrl
									})`,
								}}
							/>
						</div>
						<div className="col-md-4">
							<div className="brand-header__logo-container">
								<img
									src={
										vehicleType === "trailer"
											? categoryInfo
													?.trailersBrandCategory
													?.logo?.sourceUrl
											: categoryInfo
													?.vehiclesBrandCategory
													?.logo?.sourceUrl
									}
									alt=""
									className="img-fluid brand-header__logo"
								/>
							</div>
						</div>
					</div>
					<div
						className="brand-header__desc"
						dangerouslySetInnerHTML={{
							__html: categoryInfo?.description,
						}}
					/>
				</div>
			</section>
			<section className="vehicles-grid">
				<div className="container">
					<div className="row">
						{groups?.map((node, index) => {
							const vehicle = node.vehicles;
							return (
								<div
									className="col-xl-3 col-md-4 col-sm-6"
									key={index}
								>
									<BrandVehicleTile
										type={vehicle.type}
										name={vehicle.name}
										price={vehicle.priceFrom}
										available={vehicle.available}
										link={
											vehicle?.availableTrailer
												? vehicle?.availableTrailer[0]
														?.uri
												: vehicle?.availableVehicle
												? vehicle?.availableVehicle[0]
														?.uri
												: ""
										}
										image={vehicle.tileImg?.sourceUrl}
										index={index}
										currency={vehicle.currency}
										askForPrice={vehicle.askForPrice}
									/>
								</div>
							);
						})}
						{vehicleType === "trailer"
							? categoryInfo.trailersBrandCategory
									?.configurator !== null && (
									<div className="col-xl-3 col-md-4 col-sm-6">
										<Configurator
											link={
												categoryInfo
													.trailersBrandCategory
													?.configuratorLink
											}
											logo={
												categoryInfo
													.trailersBrandCategory
													?.logoSmall?.sourceUrl
											}
											soon={
												categoryInfo
													.trailersBrandCategory
													?.configuratorSoon
											}
										/>
									</div>
							  )
							: vehicleType === "vehicle"
							? categoryInfo.vehiclesBrandCategory
									?.configurator !== null && (
									<div className="col-xl-3 col-md-4 col-sm-6">
										<Configurator
											link={
												categoryInfo
													.trailersBrandCategory
													?.configuratorLink
											}
											logo={
												categoryInfo
													.vehiclesBrandCategory
													?.logoSmall?.sourceUrl
											}
											soon={
												categoryInfo
													.vehiclesBrandCategory
													?.configuratorSoon
											}
										/>
									</div>
							  )
							: ""}
					</div>
				</div>
			</section>
			<section className="vehicles-list">
				<div className="container">
					{groups?.map((node, index) => {
						const vehicle = node.vehicles;
						return (
							<BrandVehicleListTile
								key={index}
								name={vehicle.name}
								image={vehicle.tileImg?.sourceUrl}
								type={vehicle.type}
								description={vehicle.descriptionNewPage}
								producentLink={vehicle.producentWebstie}
								available={vehicle.available}
								link={
									vehicle?.availableTrailer
										? vehicle?.availableTrailer[0]?.uri
										: vehicle?.availableVehicle
										? vehicle?.availableVehicle[0]?.uri
										: ""
								}
								index={index}
								currency={vehicle.currency}
							/>
						);
					})}
				</div>
			</section>
			<section className="new-vehicles-available">
				<div className="container">
					<AvailableVehiclesSlider
						vehicles={availableVehicles}
						trailers={availableTrailers}
					/>
				</div>
			</section>
			<section className="brands-tiles">
				<div className="container">
					<SectionHeader
						title="Pojazdy nowe - nasze marki"
						variant="singleBig"
					/>
					<div className="row">
						{sortedBrands?.map((node, index) => {
							const brand = node.node;
							const vehicleType = brand.vehicleType.vehicleType;
							return (
								brand.trailersBrandCategory?.hideBrand !==
									true &&
								brand.vehiclesBrandCategory?.hideBrand !==
									true && (
									<div className="col-md-4" key={index}>
										<BrandTile
											type={
												vehicleType === "trailer"
													? "przyczepy"
													: "kampery"
											}
											logo={
												vehicleType === "trailer"
													? brand
															.trailersBrandCategory
															?.logoSmall
															?.sourceUrl
													: brand
															.vehiclesBrandCategory
															?.logoSmall
															?.sourceUrl
											}
											link={brand.uri}
										/>
									</div>
								)
							);
						})}
					</div>
				</div>
			</section>
			<section className="single-brand-team" id="dzial-sprzedazy">
				<div className="container">
					<SectionHeader
						title="Dział sprzedaży pojazdów kempingowych"
						subtitle="NASZ ZESPÓŁ"
						reversed={true}
					/>
					<div className="row">
						{Object.values(salesTeam)?.map((node, index) => {
							const person = node.node.singleTeam;
							return (
								<div className="col-md-3" key={index}>
									<TeamPersonTile
										name={person.fullname}
										jobName={person.jobname}
										avatar={person.avatar?.sourceUrl}
										phone={person.phone}
										email={person.email}
									/>
								</div>
							);
						})}
					</div>
				</div>
			</section>
		</Layout>
	);
};

export const query = graphql`
	query {
		brands: allWpTrailerBrand {
			edges {
				node {
					name
					uri
					slug
					trailersBrandCategory {
						logoSmall {
							sourceUrl
						}
						hideBrand
					}
					vehicleType {
						vehicleType
					}
				}
			}
		}
		vehiclesBrands: allWpVehicleBrand {
			edges {
				node {
					name
					uri
					slug
					vehiclesBrandCategory {
						logoSmall {
							sourceUrl
						}
						hideBrand
					}
					vehicleType {
						vehicleType
					}
				}
			}
		}
		salesTeam: allWpTeam(
			filter: { singleTeam: { sellTeam: { eq: "true" } } }
		) {
			edges {
				node {
					singleTeam {
						sellTeam
						email
						fullname
						jobname
						phone
						avatar {
							sourceUrl
						}
					}
				}
			}
		}
		availableVehicles: allWpVehicle(
			filter: {
				vehicles: {
					groupOrSingle: { eq: "single" }
					available: { eq: true }
				}
			}
		) {
			edges {
				node {
					uri
					slug
					vehicles {
						available
						name
						gallery {
							sourceUrl
						}
					}
					vehiclesBrand {
						nodes {
							vehiclesBrandCategory {
								logoSmall {
									sourceUrl
								}
							}
						}
					}
				}
			}
		}
		availableTrailers: allWpTrailer(
			filter: {
				vehicles: {
					groupOrSingle: { eq: "single" }
					available: { eq: true }
				}
			}
		) {
			edges {
				node {
					uri
					slug
					vehicles {
						available
						name
						gallery {
							sourceUrl
						}
					}
					trailersBrand {
						nodes {
							trailersBrandCategory {
								logoSmall {
									sourceUrl
								}
							}
						}
					}
				}
			}
		}
	}
`;

export default TrailerBrandPage;
